import { qsa } from "../utils/dom"

const setCellSizes = () => {
  /* Set to animation deplay. Takes time to actually calculate cell margins
   * it seems. Rewrite perhaps. */
  setTimeout(() => {
    for (const parent of qsa(".masonry")) {
      const style = getComputedStyle(parent)
      const gap = Number.parseInt(style.rowGap, 10) || 0
      const height = Number.parseInt(style.gridAutoRows, 10) + gap

      for (const cell of parent.children) {
        if (cell.matches(".masonry__cell")) {
          let cellHeight = gap
          for (const child of cell.children) {
            cellHeight += child.getBoundingClientRect().height
          }
          const span = Math.ceil(cellHeight / height)
          cell.style.gridRowEnd = `span ${span}`
        }
      }
    }
  }, 100)
}

export function initMasonry() {
  if (CSS.supports("grid-template-rows", "masonry")) {
    // Nice, we're done
    return
  }

  setCellSizes()
  window.addEventListener("load", setCellSizes)
  window.addEventListener("resize", setCellSizes)
  window.addEventListener("masonry", setCellSizes)
}
